import { Controller } from 'stimulus';
import initIntlTelephoneInput from '../lib/telephone_input';

export default class extends Controller {
  connect() {
    initIntlTelephoneInput();
  }
}
